export enum EResultsSortingMode {
  TIME = 'SORT_BY_TIME',
  SCORE = 'SORT_BY_SCORE',
  PRICE = 'SORT_BY_PRICE',
  DURATION = 'SORT_BY_DURATION',
  CARBON_FOOTPRINT = 'SORT_BY_CARBON_FOOTPRINT',
}

/** Why a search produced no results, when it failed rather than found nothing. */
export enum ESearchError {
  /** The API refused the search for want of a session: the visitor's browser failed the challenge. */
  SESSION = 'SESSION',
}
